<template>
  <div id="ScoreBoard">
    <div style="position: relative">
      <div style="text-align: center; font-size: 100px; font-weight: bold; position: absolute; bottom: 8px; left: 50%; transform: translate(-50%, 0);">{{ scoreBoardTeamScore }}</div>
      <span style="display: block; text-align: right; font-weight: bold;">dB</span>
      <div style="width: 270px;text-align: center; font-size: 14px; font-weight: bold; background-color: white; color: black; border-radius: 3px;">{{ scoreBoardTeamName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScoreBoard",
  props: {
    scoreBoardTeamName: {
      type: String,
      default: 'Aチーム'
    },
    scoreBoardTeamScore: {
      type: Number,
      default: 0
    },
  }
}
</script>

<style scoped>

</style>
